import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_USERASSET_REGISTRY_KEY, META_TYPE, META_VER } from './userAssetCommandRegisteryType';

/**
 * Registers the /myassets command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /myassets list — opens the UserAssetWidget card.
 */
export function registerUserAssetCommand() {
    commandEngine.register('/myassets', {
        hint: 'Open my assets',
        params: [{ name: 'view', options: [{ label: 'List', value: 'list' }] }],
        handler: () => {
            cardPainterManager.openCard(CMD_USERASSET_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
